export const ONLY_NUMBERS = /[^0-9]/g;
export const ONLY_NUMBERS_AND_DECIMAL = /[^0-9.]/g;
export const FORMAT_DATE_MM_DD = /^(\d{2})(\d+)/;
export const FORMAT_DATE_MM_DD_YYYY = /^(\d{2})\/?(\d{2})\/?(\d+)/;
export const EMAIL_REGEX =
  /^[a-zA-Z0-9._-]+\+*[a-zA-Z0-9._-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
export const PHONE_REGEX = /^\([2-9]\d{2}\) [2-9]\d{2}-\d{4}$/;
export const NAME_FIELD_REGEX = /^[A-Za-z\s'’-]+$/;
export const VERIFY_CODE_REGEX = /^\d{4}$/;
export const ZIP_CODE_REGEX = /^\d{5}(?:-\d{4})?$/;
